import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { SwpToastComponent } from 'src/app/shared/swp-components/swp-toast/swp-toast.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterModule, HeaderComponent, FooterComponent, SwpToastComponent],
  template: `
    <div class="main-wrapper">
      <app-header></app-header>
      <main class="main-container">
        <swp-toast></swp-toast>
        <router-outlet></router-outlet>
      </main>
      <app-footer></app-footer>
    </div>
  `,
  styles: [
    `
      .main-wrapper {
        display: flex;
        flex-direction: column;
        height: 100vh;
      }
      .main-container {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        padding: 1rem 1rem 0;
      }

      .main-wrapper:has(app-logistics-module) {
        height: 100dvh;
        overflow: hidden;
      }

      .main-wrapper:has(app-logistics-module) > app-header,
      .main-wrapper:has(app-logistics-module) > app-footer {
        flex: 0 0 auto;
      }

      .main-container:has(> app-logistics-module) {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .main-container:has(> app-logistics-module) > router-outlet {
        display: none;
      }
    `,
  ],
})
export class MainLayoutComponent {}
